// Generated by CoffeeScript 2.4.1
(function() {
  // Signature error using code and message
  module.exports = function(code, message) {
    var error;
    error = new Error(message);
    error.code = code;
    return error;
  };

}).call(this);
